import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = { class: "instagram-widget__item" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_vue_instagram = _resolveComponent("vue-instagram")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'content-block': !_ctx.previewModeOnly})
  }, [
    (!_ctx.previewModeOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
          _createElementVNode("h2", { class: "mb-4" }, " Latest Posts ", -1),
          _createElementVNode("p", null, [
            _createTextVNode(" Follow @Brooklyn on Instagram and use #Brooklyn to be"),
            _createElementVNode("br"),
            _createTextVNode(" featured on our home page ")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createVNode(_component_vue_instagram, {
      token: _ctx.accessToken,
      count: 8,
      "media-type": "image",
      tags: _ctx.tags,
      class: _normalizeClass(["d-flex flex-wrap", {'instagram-widget': !_ctx.previewModeOnly}])
    }, {
      feeds: _withCtx((props) => [
        _createVNode(_component_v_flex, {
          sm3: "",
          class: "pa-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: props.feed.images.standard_resolution.url,
                alt: ""
              }, null, 8, _hoisted_3),
              _createElementVNode("a", {
                class: "instagram-widget__item-link",
                href: props.feed.link,
                target: "_blank"
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("svg", {
                  width: "20",
                  height: "20",
                  viewBox: "0 0 20 20",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M5.48871 0H14.4007C17.4274 0 19.8898 2.46235 19.8896 5.48882V14.4008C19.8896 17.4273 17.4274 19.8896 14.4007 19.8896H5.48871C2.46224 19.8896 0 17.4274 0 14.4008V5.48882C0 2.46235 2.46224 0 5.48871 0ZM14.4008 18.1249C16.4544 18.1249 18.1251 16.4544 18.1251 14.4008H18.1249V5.48882C18.1249 3.43541 16.4542 1.76471 14.4007 1.76471H5.48871C3.43529 1.76471 1.76471 3.43541 1.76471 5.48882V14.4008C1.76471 16.4544 3.43529 18.1251 5.48871 18.1249H14.4008Z",
                    fill: "white"
                  }),
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M4.81982 9.94488C4.81982 7.11888 7.11888 4.81982 9.94488 4.81982C12.7709 4.81982 15.0699 7.11888 15.0699 9.94488C15.0699 12.7708 12.7709 15.0697 9.94488 15.0697C7.11888 15.0697 4.81982 12.7708 4.81982 9.94488ZM6.58453 9.94477C6.58453 11.7976 8.09206 13.3049 9.94488 13.3049C11.7977 13.3049 13.3052 11.7976 13.3052 9.94477C13.3052 8.09182 11.7978 6.58441 9.94488 6.58441C8.09194 6.58441 6.58453 8.09182 6.58453 9.94477Z",
                    fill: "white"
                  }),
                  _createElementVNode("path", {
                    d: "M15.2848 3.32373C14.9448 3.32373 14.6108 3.46138 14.3707 3.70255C14.1294 3.94255 13.9907 4.27667 13.9907 4.61785C13.9907 4.95797 14.1295 5.29197 14.3707 5.53314C14.6107 5.77314 14.9448 5.91197 15.2848 5.91197C15.626 5.91197 15.959 5.77314 16.2001 5.53314C16.4413 5.29197 16.579 4.95785 16.579 4.61785C16.579 4.27667 16.4413 3.94255 16.2001 3.70255C15.9601 3.46138 15.626 3.32373 15.2848 3.32373Z",
                    fill: "white"
                  })
                ], -1)
              ]), 8, _hoisted_4)
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["token", "tags", "class"])
  ], 2))
}